import Reducers from "./reducers";
import { createStore } from "redux";

export default createStore(Reducers);
